export default __webpack_public_path__ + "static/marquee-img1-6a1c423b0146c78addf21b40e4792c50.png";